import { FormattedMessage, useIntl } from "@/i18n/i18n-client";
import { LoginMethod } from "@/templates/types/LoginFormProps";
import { Control, UseFormRegister, FieldErrors } from "react-hook-form";
import FormField from "@/components/FormField";
import StorePhoneInput from "@/components/StorePhoneInput";
import NameInputField from "@/components/Fields/NameInputField";
import EmailInputField from "@/components/Fields/EmailInputField";

interface SignupFormProps {
  method: LoginMethod;
  setSignupName: (name: string) => void;
  setSignupEmail: (email: string) => void;
  signupPhone: string;
  setSignupPhone: (phone: string) => void;
  control: Control<any>;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  cachedCountry?: string;
}

const SignupForm = ({
  method,
  setSignupName,
  setSignupEmail,
  setSignupPhone,
  control,
  register,
  errors,
  cachedCountry,
}: SignupFormProps) => {
  const intl = useIntl();

  return (
    <div className="flex flex-col w-full gap-6">
      <div className="flex flex-col w-full gap-6">
        <NameInputField
          register={register}
          error={errors?.signupName}
          fieldName="signupName"
          label={<FormattedMessage defaultMessage="Your name" id="vlKhIl" />}
          placeholder={intl.formatMessage({
            defaultMessage: "Enter your full name",
            id: "xIDmuE",
          })}
          registerOptions={{
            onChange: (e) => setSignupName(e.target.value),
            validate: (value) => {
              const trimmedValue = value?.trim();
              const words = trimmedValue
                ?.split(/\s+/)
                .filter((word: string) => word.length > 0);
              if (words && words.length < 2) {
                return intl.formatMessage({
                  defaultMessage:
                    "Please enter your full name (first and last name)",
                  id: "/4OSXG",
                });
              }
              return true;
            },
          }}
        />

        {method === LoginMethod.EMAIL ? (
          <FormField
            label={
              <FormattedMessage defaultMessage="Phone number" id="jdJhOL" />
            }
            error={undefined}
            className="w-full"
            showStrick={false}
          >
            <StorePhoneInput
              control={control}
              fieldName="signupPhoneNumber"
              placeholder="Enter your phone number"
              defaultCountry={cachedCountry}
              rules={{
                required: intl.formatMessage({
                  defaultMessage: "Phone number is required",
                  id: "UHu1T/",
                }),
                onChange: (value) => {
                  setSignupPhone(value);
                },
              }}
            />
          </FormField>
        ) : (
          <EmailInputField
            register={register}
            error={errors?.signupEmail}
            fieldName="signupEmail"
            className="!w-full"
            label={
              <FormattedMessage defaultMessage="Email address" id="hJZwTS" />
            }
            placeholder={intl.formatMessage({
              defaultMessage: "Enter your email address",
              id: "NgCT/u",
            })}
            registerOptions={{
              onChange: (e) => setSignupEmail(e.target.value),
            }}
          />
        )}
      </div>
    </div>
  );
};

export default SignupForm;
